// extracted by mini-css-extract-plugin
export default {"root":"GridBase_root__-WG9o"};